import type { Nullable, Nullish } from "@iot-platform/core";
import { UserRoleEnumDto } from "@user/data/dto/user-role.dto";
import { UserRoleEnum } from "@user/domain/models/user-role.model";
import { injectable } from "inversify";

@injectable()
export class UserRoleEnumMapper {
    /** Takes the raw backend role: anything that is not a known role maps to `null`. */
    map(userRoleEnumDto: Nullish<string>): Nullable<UserRoleEnum> {
        switch (userRoleEnumDto) {
            case UserRoleEnumDto.FieldTech:
                return UserRoleEnum.FieldTech;
            case UserRoleEnumDto.SuperUser:
                return UserRoleEnum.SuperUser;
            default:
                return null;
        }
    }

    mapToDto(userRoleEnum: UserRoleEnum): UserRoleEnumDto {
        switch (userRoleEnum) {
            case UserRoleEnum.FieldTech:
                return UserRoleEnumDto.FieldTech;
            case UserRoleEnum.SuperUser:
                return UserRoleEnumDto.SuperUser;
            default: {
                const exhaustiveRole: never = userRoleEnum;
                return exhaustiveRole;
            }
        }
    }
}
